import { render, staticRenderFns } from "./ArrivalsDeparture.vue?vue&type=template&id=7e684983&scoped=true"
import script from "./ArrivalsDeparture.vue?vue&type=script&setup=true&lang=js"
export * from "./ArrivalsDeparture.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e684983",
  null
  
)

export default component.exports